import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewAuditTrail from "../../../../components/@audit/NewAuditTrail";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AuditTrailNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewAuditTrail
                routeType={routeType}
            />
        </SettingFrame>
    )
}       